function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from 'react';
import styled from 'styled-components';
import { borderRadius, display } from 'styled-system';
import Text from './Text';
const StyledPill = styled(Text).withConfig({
  displayName: "Pill__StyledPill",
  componentId: "sc-1dshf1p-0"
})(["", " ", ""], borderRadius, display);
const Pill = /*#__PURE__*/memo(_ref => {
  let {
    bg = 'darkBlue',
    borderRadius = '100px',
    color = 'white',
    display = 'inline-block',
    fontSize = 1,
    lineHeight = 1,
    px = 2,
    py = 1,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledPill, _extends({
    bg: bg,
    borderRadius: borderRadius,
    color: color,
    display: display,
    fontSize: fontSize,
    lineHeight: lineHeight,
    px: px,
    py: py
  }, props));
});
Pill.propTypes = {
  ...borderRadius.propTypes,
  ...display.propTypes,
  ...Text.propTypes
};
Pill.displayName = 'Pill';
export default Pill;